import type { ProductImageConversion } from '../components/Common/ProductImage';

const PRODUCT_URLS = {
  intersport: (params: { brand: string; name: string; sapId: string }) =>
    `https://www.intersport.fi/fi/tuote/${params.brand}-${params.name}-${params.sapId}`,
  budgetsport: (params: { brand: string; name: string; color: string; sapId: string }) =>
    `https://www.budgetsport.fi/tuote/${params.brand}-${params.name}-${params.color}-${params.sapId}`,
};

export function getConversionUrl(url: string, conversion: ProductImageConversion = 'system_150') {
  if (typeof url !== 'string') {
    return url;
  }
  const imgUrl = String(url);
  return imgUrl.includes('/file/dl/i/')
    ? imgUrl.replace('/file/dl/i/', `/file/dl/c=${conversion}/`)
    : `${imgUrl}?c=${conversion}`;
}

export function createProductUrl({
  chain = 'intersport',
  brand = '',
  name = '',
  sapId = '',
  colors = [],
}: {
  chain: 'intersport' | 'budgetsport';
  brand: string;
  name: string;
  sapId: string;
  colors: string[];
}) {
  if (brand === null) brand = '';
  if (name === null) name = '';
  if (sapId === null) sapId = '';
  const params = {
    sapId: sapId,
    brand: brand.toLowerCase().trim().replace(/ /g, '-'),
    name: slugify(name),
    color: colors[0]?.toLowerCase().trim().replace(/ /g, '-') || '',
  };
  return PRODUCT_URLS[chain](params);
}

export function getProductName(rawName: string) {
  const wordArr = rawName.toLowerCase().split(' ');
  wordArr.shift();
  return wordArr.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export function slugify(str: string) {
  str = str.replace(/^\s+|\s+$/g, '');
  // Make the string lowercase
  str = str.toLowerCase();
  // Remove accents, swap ñ for n, etc
  const from =
    'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;';
  const to =
    'AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  // Remove invalid chars
  str = str
    .replace(/[^a-z0-9 -/.]/g, '')
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-')
    // Collapse dashes
    .replace(/-+/g, '-');
  return str;
}

export function capitalizeFirstLetter(string = '') {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function generateUuid() {
  return 'xxxxxxxxxxxx4xxxyxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r && 0x3) || 0x8;
    return v.toString(16);
  });
}

export function capitalizeFirstChar(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Remove special characters from string (for SAP). Accepts only letters (including å, ä and ö), numbers and spaces.
 *
 * @param {string} str - String to remove special characters from.
 * @returns {string} String without special characters.
 */
export function removeSpecialCharacters(str: string) {
  return String(str).replace(/[^a-zA-Z0-9åäöÅÄÖ ]/g, '');
}
